module.exports = __webpack_public_path__ + "nagorik-a0923a4359c7ef6bdc23.svg";